import React, { useState, useEffect } from 'react'
import Pagination from '../../Common/Pagination';
import { dateFormat } from '../../libs/Util';

const TopicList = (props) => {
    const [currentPage, setCurrentPage] = useState(props.state.currentPage);
    const [pageCount, setPageCount] = useState(props.state.pageCount);
    const [topicList, setTopicList] = useState(props.state.topicList);

    useEffect(() => {
        setTopicList(props.state.topicList);
        setCurrentPage(props.state.currentPage);
    });

    const handleClick = (id) => {
        if (document.getElementById('searchKeyword').value !== '') {
            props.fnSearchTopic(id);
        } else {
            props.fnOnChangeMode('topicList', id);
        }
    }
    const onKeyPress = (e) => {
        if (e.key === 'Enter') {
            props.fnSearchTopic(1);
        }
    }
    const renderTopicList = () => {
        let list = [];
        for (let i = 0; i < topicList.length; i++) {
            list.push(
                <tr key={i}>
                    <td>
                        <div className="ctgr">{topicList[i].catagoryName}</div>
                    </td>
                    <td>
                        <div className="topic-title-wrap">
                            <a href={() => { }} onClick={() => props.fnOnChangeMode('topicView', props.state.currentPage, topicList[i].topicSeq)} className="topic-title">{topicList[i].title}</a>
                            {topicList[i].subTopicCount !== 0
                                ? <div className="topic-tag reply"><i className='icoKdc16 chat'></i>{topicList[i].subTopicCount}</div> : null}
                            {topicList[i].isNewSubTopic === '1' && Math.ceil((new Date().getTime() - new Date(topicList[i].writeDate).getTime()) / (1000 * 3600 * 24)) < 30
                                ? <div className="topic-tag new">NEW</div> : null}
                        </div>
                    </td>
                    <td>
                        <div onClick={e => props.fnBtnOnPopup(topicList[i], e)} className="author">
                            <div className="pf" style={{ backgroundColor: topicList[i].colorCode }}>
                                {topicList[i].writerFirstInitial}
                            </div>
                            <a href={() => { }} className="name">{topicList[i].writer}</a>
                        </div>
                    </td>
                    <td>
                        <span className="date">{dateFormat(new Date(topicList[i].writeDate))}</span>
                    </td>
                </tr>
            );
        }
        return list;
    }
    const setPaging = (type) => {
        if (type === 'prev') {
            if (document.getElementById('searchKeyword').value !== '') {
                props.fnSearchTopic(currentPage - 1);
            } else {
                props.fnOnChangeMode('topicList', currentPage - 1);
            }
        } else {
            if (document.getElementById('searchKeyword').value !== '') {
                props.fnSearchTopic(currentPage + 1);
            } else {
                props.fnOnChangeMode('topicList', currentPage + 1);
            }
        }
    }
    return (
        <div className="qna-wrap">
            <h3 className='myinfo-cnts-title'>{props.topicListTitle}</h3>
            <section className="qna-list">
                <div className="ctgr-wrap">
                    <div className="select-search-wrap">
                        <div className="select-wrap">
                            <select className="ctgr-select" id="ctgrSelect">
                                <option value="1">전체</option>
                                <option value="2">제목</option>
                                <option value="3">내용</option>
                            </select>
                        </div>
                        <div className="search-wrap">
                            <button className="btn-search" onClick={e => props.fnSearchTopic(1)}><i className="icoKdc24 magnifier-b"></i></button>
                            <input id="searchKeyword" type="text" placeholder="검색" onKeyDown={e => onKeyPress(e)} />
                        </div>
                    </div>

                    {!props.isAdmin && !props.isEditor && props.companyType !== '0'
                        ? (    
                        <button className="btn-new-topic btn-primary" onClick={e => props.fnOnChangeMode('topicWrite')}>{props.btnTopicWriteName}</button>
                        )
                        : null}
                </div>
                {topicList.length !== 0
                    ? <div className="board-wrap">
                        <table className="board">
                            <colgroup>
                                <col width="110px" ></col>
                                <col width="*" ></col>
                                <col width="100px" ></col>
                                <col width="136px" ></col>
                            </colgroup>
                            <tbody>
                                {renderTopicList()}
                            </tbody>
                        </table>
                    </div>
                    : <div className="no-item">
                        <i className="i-no-qna"></i>
                        <p className="txt">{props.state.current === 'topicSearch' ? '검색된 내용이 없습니다' : '작성된 1:1문의가 없습니다'}</p>
                    </div>}
            </section>
            <Pagination totalCount={topicList ? topicList[0]?.totalCount : 0} pageCount={pageCount} currentPage={currentPage} setCurrentPage={handleClick} setPaging={setPaging} />
        </div>
    );
}
export default TopicList;